export const PartialIconSvg = () => (
  <svg
    data-testid="partial-icon-svg"
    xmlns="http://www.w3.org/2000/svg"
    className="absolute pointer-events-none"
    width={24}
    height={24}
    fill="none"
  >
    <path fill="#fff" d="M19.5 13h-14v-2h14v2Z" />
  </svg>
)
export default PartialIconSvg
